import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TicketViewsComponent } from '@routes/tickets/ticket-views/ticket-views.component';
import { TicketsComponent } from '@routes/tickets/tickets.component';

const routes: Routes = [
  // { path: '', redirectTo: 'tickets', pathMatch: 'full' },
  { path: '', component: TicketViewsComponent },
  { path: ':ticketNo', component: TicketsComponent },
  { path: 'new/:ticketNo', component: TicketsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TicketsRoutingModule {
}
